module.exports = __webpack_public_path__ + "static/media/banner2.8aab766b.png";